import { useRoutes } from 'react-router-dom';

// import { Login } from '@/features/auth';
import { useAuth } from '@/lib/auth';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import storage from '@/utils/storage';

export const AppRoutes = () => {
  const auth = useAuth();

  // const commonRoutes = [{ path: '/', element: auth.user ? <Availablity /> : <Login /> }];
  // const commonRoutes = [{ path: '/', element: <Login /> }];

  // const routes = auth.user ? protectedRoutes : publicRoutes;
  const routes = protectedRoutes ;

  const element = useRoutes([...routes]);

  return <>{element}</>;
};
